var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('Snow',{attrs:{"color":"#fff","zIndex":"999"}}),_c('div',{staticClass:"container"},[_c('top-header')],1),_c('router-view'),_c('bottomFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }